















import { Prop, Component, Vue, Watch } from 'vue-property-decorator'

export interface CreateAttachmentModel {
    file: File
}

// @todo: this whole component is a bit pointless, maybe move it back to Detail view? (copied from AssignToForm)

@Component
export default class CreateAttachmentForm extends Vue {
    @Prop() readonly value!: CreateAttachmentModel
    error: boolean = false
    validFileTypes: string[] = [
        'image/*',
        '.doc',
        '.docx',
        '.xlsx',
        '.xlsm',
        '.xltx',
        '.xltm',
        '.ppt',
        '.pptx',
        '.pptjpeg',
        '.pptpng',
        '.pdf',
        '.txt',
        '.csv',
    ]

    @Watch('value.file')
    onFileChange(file) {
        this.error = false

        const type = file.type
        const explode = file.name.split('.').pop()

        if (!type.includes('image') && !this.validFileTypes.includes('.' + explode)) {
            this.error = true
        }
        this.$emit('FileTypeError', this.error)
    }
}
